class counter{
	constructor(element, atts={}){
		this.animate = this.animate.bind(this);
		this.element = element;
		this.duration = atts.duration || '2000';
		this.suffex = /\D*$/.exec(this.element.innerHTML);
		this.value = parseInt( this.element.innerHTML.replace(',','') );
		this.element.innerHTML = '0';
		this.done = false;
		this.start = false;
		//https://gist.github.com/gre/1650294
		this.EasingFunctions = {
			// no easing, no acceleration
			linear: function (t) { return t },
			// accelerating from zero velocity
			easeInQuad: function (t) { return t*t },
			// decelerating to zero velocity
			easeOutQuad: function (t) { return t*(2-t) },
			// acceleration until halfway, then deceleration
			easeInOutQuad: function (t) { return t<.5 ? 2*t*t : -1+(4-2*t)*t },
			// accelerating from zero velocity
			easeInCubic: function (t) { return t*t*t },
			// decelerating to zero velocity
			easeOutCubic: function (t) { return (--t)*t*t+1 },
			// acceleration until halfway, then deceleration
			easeInOutCubic: function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 },
			// accelerating from zero velocity
			easeInQuart: function (t) { return t*t*t*t },
			// decelerating to zero velocity
			easeOutQuart: function (t) { return 1-(--t)*t*t*t },
			// acceleration until halfway, then deceleration
			easeInOutQuart: function (t) { return t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t },
			// accelerating from zero velocity
			easeInQuint: function (t) { return t*t*t*t*t },
			// decelerating to zero velocity
			easeOutQuint: function (t) { return 1+(--t)*t*t*t*t },
			// acceleration until halfway, then deceleration
			easeInOutQuint: function (t) { return t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t }
		}
		this.observerCallback = this.observerCallback.bind(this);
		this.observer = new IntersectionObserver( this.observerCallback, {
			threshold: 1.0
		} );
		this.observer.observe( this.element );
	}

	observerCallback( entries, observer ){
		entries.forEach( entry => {
			if( entry.intersectionRatio >= 1 && this.done == false && this.start == false ){
				requestAnimationFrame( this.animate );
				this.start = true;
			}
		} );
	}

	animate(timestamp){
		if( !this.start ) this.start = timestamp;
		if( timestamp - this.start > this.duration ) this.start = timestamp;
		let progress = ( timestamp - this.start ) / this.duration
		progress = this.EasingFunctions.easeOutQuint(progress);
		let value = this.value * progress;
		value = Math.round(Math.min( value, this.value ));
		if( value == this.value ){
			this.done = true;
		}
		this.element.innerHTML = this.addCommas( value ) + this.suffex;
		if( !this.done ){
			requestAnimationFrame( this.animate );
		}
	}

	addCommas(number){
		while (/(\d+)(\d{3})/.test(number.toString())){
			number = number.toString().replace(/(\d+)(\d{3})/, '$1'+','+'$2');
		}
		return number;
	}

}

class counter_controller{
	/**
	 * this function is run as soon as possible.
	 * the dom isn't neccessarily loaded / parsed
	 **/
	constructor(){
		//If we don't have the intersection observer function, don't animate. Only <=ie11
		if( typeof window.IntersectionObserver != "function" ){
			return
		}
		this.domloaded = this.domloaded.bind(this);
		//check to see if the dom has loaded yet
		if(document.readyState === "loading"){
			//if the dom hasn't loaded, wait until it is
			document.addEventListener("readystatechange",this.domloaded);

		} else {
			//if it has, run the domloaded function
			this.domloaded();
		}
	}

	/**
	 * this function is run as soon as the dom is loaded
	 **/
	domloaded(){
		//make sure we don't run this twice
		document.removeEventListener("readystatechange",this.domloaded);
		document.querySelectorAll('.stat .left').forEach(el=>{
			new counter(el);
		});
	}

}

new counter_controller();
